import { useCallback, useRef, useEffect } from "react";
const getGrecaptcha = (enterprise) => new Promise((resolve) => {
  var _a, _b;
  (_a = window.___grecaptcha_cfg) != null ? _a : window.___grecaptcha_cfg = {
    fns: []
  };
  if (enterprise) {
    ((_b = window == null ? void 0 : window.grecaptcha) == null ? void 0 : _b.enterprise) ? resolve(window.grecaptcha.enterprise) : window.___grecaptcha_cfg.fns.push(() => resolve(window.grecaptcha.enterprise));
  } else {
    (window == null ? void 0 : window.grecaptcha) ? resolve(window.grecaptcha) : window.___grecaptcha_cfg.fns.push(() => resolve(window.grecaptcha));
  }
});
const executeGrecaptcha = async (enterprise, siteKey, action) => {
  const grecaptcha = await getGrecaptcha(enterprise);
  return grecaptcha.execute(siteKey, { action });
};
const hideGrecaptcha = async (enterprise) => {
  const grecaptcha = await getGrecaptcha(enterprise);
  grecaptcha.ready(() => {
    const badge = document.querySelector(".grecaptcha-badge");
    if (badge)
      badge.style.visibility = "hidden";
  });
};
const showGrecaptcha = async (enterprise) => {
  const grecaptcha = await getGrecaptcha(enterprise);
  grecaptcha.ready(() => {
    const badge = document.querySelector(".grecaptcha-badge");
    if (badge)
      badge.style.visibility = "visible";
  });
};
const generateGrecaptchaSrc = (siteKey, options) => {
  const language = (options == null ? void 0 : options.language) ? `&hl=${options.language}` : "";
  const script = (options == null ? void 0 : options.enterprise) ? "enterprise.js" : "api.js";
  const host = (options == null ? void 0 : options.recaptchaNet) ? "recaptcha.net" : "google.com";
  return `https://www.${host}/recaptcha/${script}?render=${siteKey}${language}`;
};
const useGoogleReCaptcha = (siteKey, options) => {
  const load = useCallback(() => {
    if (document.getElementById(siteKey))
      return;
    const script = document.createElement("script");
    script.async = true;
    script.type = "text/javascript";
    script.src = generateGrecaptchaSrc(siteKey, options);
    script.id = siteKey;
    document.getElementsByTagName("head")[0].appendChild(script);
  }, [options, siteKey]);
  const hideGoogleReCaptcha = useCallback(() => hideGrecaptcha(!!(options == null ? void 0 : options.enterprise)), [options == null ? void 0 : options.enterprise]);
  const showGoogleReCaptcha = useCallback(() => showGrecaptcha(!!(options == null ? void 0 : options.enterprise)), [options == null ? void 0 : options.enterprise]);
  const executeGoogleReCaptcha = useCallback((action) => executeGrecaptcha(!!(options == null ? void 0 : options.enterprise), siteKey, action), [options == null ? void 0 : options.enterprise, siteKey]);
  const oneTimeRef = useRef(false);
  useEffect(() => {
    if (oneTimeRef.current)
      return;
    oneTimeRef.current = true;
    (options == null ? void 0 : options.hide) && hideGoogleReCaptcha();
    load();
  }, [load, hideGoogleReCaptcha, options]);
  return {
    executeGoogleReCaptcha,
    hideGoogleReCaptcha,
    showGoogleReCaptcha
  };
};
export { useGoogleReCaptcha };
